type Transaction = {
  transactionId: string;
  createdAt: number;
  destinationAmount: number;
  destinationCurrency: string;
  originAmount: number;
  originCurrency: string;
  destinationUserId: string;
  originUserId: string;
  type: string;
  status: string;
};

export default Transaction

const data = [
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 2000,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 2000,
    },
    timestamp: {
      $numberLong: "1646041508000",
    },
    transactionId: "v1-296193",
    destinationUserId: "69887",
    originUserId: "69887",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 100,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 100,
    },
    timestamp: {
      $numberLong: "1645144589000",
    },
    transactionId: "v1-426518",
    destinationUserId: "119049",
    originUserId: "119049",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 295,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 295,
    },
    timestamp: {
      $numberLong: "1645144614000",
    },
    transactionId: "v1-426519",
    destinationUserId: "119049",
    originUserId: "119049",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 500,
    },
    timestamp: {
      $numberLong: "1645144993000",
    },
    transactionId: "v1-426525",
    destinationUserId: "65895",
    originUserId: "65895",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "AVAX",
      transactionAmount: 0.49,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "AVAX",
      transactionAmount: 0.49,
    },
    timestamp: {
      $numberLong: "1645147012000",
    },
    transactionId: "v1-426528",
    destinationUserId: "52790",
    originUserId: "52790",
    type: "CRYPTO_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 458.08,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 458.08,
    },
    timestamp: {
      $numberLong: "1645145580000",
    },
    transactionId: "v1-426531",
    destinationUserId: "69222",
    originUserId: "69222",
    type: "FIAT_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "FTM",
      transactionAmount: 866.52,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "FTM",
      transactionAmount: 866.52,
    },
    timestamp: {
      $numberLong: "1645146810000",
    },
    transactionId: "v1-426548",
    destinationUserId: "18661",
    originUserId: "18661",
    type: "CRYPTO_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 10000,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 10000,
    },
    timestamp: {
      $numberLong: "1645148040000",
    },
    transactionId: "v1-426558",
    destinationUserId: "69555",
    originUserId: "69555",
    type: "FIAT_WITHDRAW",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 52,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 52,
    },
    timestamp: {
      $numberLong: "1645148780000",
    },
    transactionId: "v1-426564",
    destinationUserId: "132955",
    originUserId: "132955",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 1250,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 1250,
    },
    timestamp: {
      $numberLong: "1645153450000",
    },
    transactionId: "v1-426568",
    destinationUserId: "75138",
    originUserId: "75138",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "BTC",
      transactionAmount: 0,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "BTC",
      transactionAmount: 0,
    },
    timestamp: {
      $numberLong: "1645153681000",
    },
    transactionId: "v1-426569",
    destinationUserId: "75138",
    originUserId: "75138",
    type: "CRYPTO_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 30.39,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 30.39,
    },
    timestamp: {
      $numberLong: "1645175520000",
    },
    transactionId: "v1-426588",
    destinationUserId: "124598",
    originUserId: "124598",
    type: "FIAT_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 302.26,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 302.26,
    },
    timestamp: {
      $numberLong: "1645168578000",
    },
    transactionId: "v1-426592",
    destinationUserId: "103769",
    originUserId: "103769",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 10000,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 10000,
    },
    timestamp: {
      $numberLong: "1645171469000",
    },
    transactionId: "v1-426598",
    destinationUserId: "53213",
    originUserId: "53213",
    type: "FIAT_DEPOSIT",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 516.15,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 516.15,
    },
    timestamp: {
      $numberLong: "1645175520000",
    },
    transactionId: "v1-426608",
    destinationUserId: "43584",
    originUserId: "43584",
    type: "FIAT_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 200,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 200,
    },
    timestamp: {
      $numberLong: "1645174218000",
    },
    transactionId: "v1-426610",
    destinationUserId: "46352",
    originUserId: "46352",
    type: "FIAT_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 6,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 6,
    },
    timestamp: {
      $numberLong: "1645175700000",
    },
    transactionId: "v1-426622",
    destinationUserId: "136492",
    originUserId: "136492",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 15000,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 15000,
    },
    timestamp: {
      $numberLong: "1645176080000",
    },
    transactionId: "v1-426628",
    destinationUserId: "98546",
    originUserId: "98546",
    type: "FIAT_DEPOSIT",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 3000,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 3000,
    },
    timestamp: {
      $numberLong: "1645176713000",
    },
    transactionId: "v1-426632",
    destinationUserId: "67035",
    originUserId: "67035",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 6790,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 6790,
    },
    timestamp: {
      $numberLong: "1645177200000",
    },
    transactionId: "v1-426638",
    destinationUserId: "29660",
    originUserId: "29660",
    type: "FIAT_WITHDRAW",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 23,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "TRY",
      transactionAmount: 23,
    },
    timestamp: {
      $numberLong: "1645180200000",
    },
    transactionId: "v1-426648",
    destinationUserId: "30848",
    originUserId: "30848",
    type: "FIAT_DEPOSIT",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 68351.34,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "EUR",
      transactionAmount: 2000,
    },
    timestamp: {
      $numberLong: "1641654664000",
    },
    transactionId: "c5a4654a-024e-4f78-adec-edf0af78a46-1",
    originUserId: "8650a2611d0771cba03310f74bf6",
    destinationUserId: "9350a2611e0771cba03310f74bf6",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 68351.34,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "EUR",
      transactionAmount: 2000,
    },
    timestamp: {
      $numberLong: "1641654664000",
    },
    transactionId: "c5a4654a-024e-4f78-adec-edf0af78a46-2",
    originUserId: "2",
    destinationUserId: "9350a2611e0771cba03310f74bf6",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 68351.34,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "EUR",
      transactionAmount: 800,
    },
    timestamp: {
      $numberLong: "1641654664000",
    },
    transactionId: "7b80a539eea6e78acbd6d458e5971482",
    originUserId: "c5a4654a-024e-4f78-adec-edf0af78a46-3",
    destinationUserId: "2",
    status: "FLAG",
  },
  {
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "EUR",
      transactionAmount: 800,
    },
    timestamp: {
      $numberLong: "1656590327153",
    },
    transactionId: "7b80a539eea6e78acbd6d458e5971482-1",
    originUserId: "8650a2611d0771cba03310f74bf6",
    destinationUserId: "9350a2611e0771cba03310f74bf6",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698930000",
    },
    transactionId: "test-r-95-2",
    destinationUserId: "test",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 1000,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698931000",
    },
    transactionId: "test-r-95-8",
    destinationUserId: "test",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 1000,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698900000",
    },
    transactionId: "tester-r-95-1",
    destinationUserId: "test1",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 1000,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698920000",
    },
    transactionId: "tester-r-95-5",
    destinationUserId: "test1",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 1000,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698920000",
    },
    transactionId: "tester-r-95-6",
    destinationUserId: "test1",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 68351.34,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "EUR",
      transactionAmount: 800,
    },
    timestamp: {
      $numberLong: "1641654664000",
    },
    transactionId: "7b80a539eea6e78abd6d458e5971482",
    originUserId: "8650a2611d0771cba03310f74bf6",
    destinationUserId: "9350a2611e0771cba03310f74bf6",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    originAmountDetails: {
      transactionCurrency: "EUR",
      transactionAmount: 800,
    },
    timestamp: {
      $numberLong: "1657698930000",
    },
    transactionId: "test-r-95-2111a",
    destinationUserId: "test",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698930000",
    },
    transactionId: "tester-r-95-111",
    destinationUserId: "test",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698930000",
    },
    transactionId: "11111111",
    destinationUserId: "test",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698933000",
    },
    transactionId: "tester1-r-95-3",
    destinationUserId: "tester1",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698936000",
    },
    transactionId: "tester1-r-95-6",
    destinationUserId: "tester1",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698939000",
    },
    transactionId: "tester1-r-95-8",
    destinationUserId: "tester2",
    status: "ALLOW",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698930000",
    },
    transactionId: "123123123123123",
    destinationUserId: "test",
    status: "FLAG",
  },
  {
    destinationAmountDetails: {
      transactionCurrency: "INR",
      transactionAmount: 500,
    },
    transactionState: "CREATED",
    timestamp: {
      $numberLong: "1657698943000",
    },
    transactionId: "testing-8",
    destinationUserId: "nikolai",
    status: "FLAG",
  },
];

const transactions = filterData()

export function getTransactions(params: {
  page: number;
  filters : FilterInterface;
  sorting : string;
}): Promise<{
  total: number;
  data: Transaction[];
}> {
  const { page, filters, sorting } = params;
  return new Promise((resolve) => {
    setTimeout(() => {
      const searchResult = sorting.length ? sortData(transactions, sorting) : transactions; 
      const compiledResults = applyFilters(filters, searchResult);
      resolve({
        total: compiledResults.length,
        data: compiledResults.slice((page - 1) * 20, page * 20),
      });
    }, 500 + Math.round(Math.random() * 3000));
  });
}
function applyFilters(filters : FilterInterface, transactions : Transaction[]) : Transaction[] {
  const {type, status, originCurrency, destinationCurrency} = filters;
  const filterResults = transactions
                        .filter(transaction => type === "All" || type === transaction.type)
                        .filter(transaction => status === "All" || transaction.status === status)
                        .filter(transaction => originCurrency === "All" || transaction.originCurrency === originCurrency)
                        .filter(transaction => destinationCurrency === "All" || transaction.destinationCurrency === destinationCurrency)
  return filterResults;
}
function filterData() : Transaction[] {
  const filteredData: Transaction[] = data.map(transaction => {
    return {
      transactionId: transaction.transactionId,
      createdAt: parseInt(transaction.timestamp.$numberLong),
      destinationAmount: transaction.destinationAmountDetails?.transactionAmount || 0,
      destinationCurrency: transaction.destinationAmountDetails?.transactionCurrency || "N/A",
      originAmount: transaction.originAmountDetails?.transactionAmount || 0,
      originCurrency: transaction.originAmountDetails?.transactionCurrency  || "N/A",
      destinationUserId: transaction.destinationUserId,
      originUserId: transaction.originUserId  || "N/A",
      type: transaction.type || "N/A",
      status: transaction.status
    }
  })
  return filteredData;
}

function sortData(data : Transaction[], sortingField : string) : Transaction[] {
  data.sort((a,b) => (a[sortingField as keyof Transaction] > b[sortingField as keyof Transaction]) ? 1 : ((b[sortingField as keyof Transaction] > a[sortingField as keyof Transaction]) ? -1 : 0));
  return data;
}

export function getAllTypes() : string[] {
  let uniqueTypes = new Set<string>();
  for(const transaction of transactions){
    uniqueTypes.add(transaction.type);
  }
  return [...uniqueTypes].sort()
}

export function getAllStatus() : string[] {
  let uniqueStatus= new Set<string>();
  for(const transaction of transactions){
    uniqueStatus.add(transaction.status);
  }
  return [...uniqueStatus].sort()
}

export function getAllOriginCurrencies() : string[] {
  let uniqueOriginCurrencies = new Set<string>();
  for(const transaction of transactions){
    uniqueOriginCurrencies.add(transaction.originCurrency);
  }
  return [...uniqueOriginCurrencies].sort()
}

export function getAllDestinationCurrencies() : string[] {
  let uniqueDestinationCurrencies = new Set<string>();
  for(const transaction of transactions){
    uniqueDestinationCurrencies.add(transaction.destinationCurrency);
  }
  return [...uniqueDestinationCurrencies].sort()
}

export interface FilterInterface {
  type : string;
  status : string;
  originCurrency: string;
  destinationCurrency :string;
}